export const options = [
  { label: 'Open', value: 'Open' },
  { label: 'Onhold', value: 'Onhold' },
  { label: 'Closed', value: 'Closed' },
];

export const columnDefs = [
  {
    field: 'candidateName',
    headerName: 'Name',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'yearsOfExperience',
    headerName: 'Exp',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'email',
    headerName: 'Email',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'location',
    headerName: 'Location',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'vendorName',
    headerName: 'Vendor Name',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'earliestAvailability',
    headerName: 'Available By',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'createdDate',
    headerName: 'Received On',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'resume',
    headerName: 'Resume',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
  {
    field: 'attachments',
    headerName: 'Initial Screening Feedback',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
  {
    field: 'url',
    headerName: 'Links',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
  {
    field: 'status',
    headerName: 'Status',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'review',
    headerName: 'Review',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
];
